import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

/** Button that shows a spinner and disables itself while `pending`. */
export function PendingButton({
  pending,
  children,
  ...props
}: React.ComponentProps<typeof Button> & { pending?: boolean }) {
  return (
    <Button disabled={pending || props.disabled} {...props}>
      {pending ? <Loader2 className="animate-spin" /> : null}
      {children}
    </Button>
  );
}
